import React, {useState, useEffect} from 'react';
import Calendar from 'react-calendar';
import 'react-calendar/dist/Calendar.css';
import {useFormContext} from "react-hook-form";
import {useDispatch} from "react-redux";

import css from './OrdersCalendarModal.module.css';
import {ordersActions} from '../../../../store/slices/orders-slices';


const OrdersCalendarModal = ({setDays, selectedDates, setSelectedDates, setLastSelectedDate}) => {
    const dispatch = useDispatch();
    const {watch} = useFormContext();

    // Отримуємо стан чекбоксів "Субота" і "Неділя"
    const watchSat = watch('sat');
    const watchSun = watch('sun');

    // Форматування дати у формат YYYY-MM-DD
    const formatDate = (date) => {
        const year = date.getFullYear();
        const month = (date.getMonth() + 1).toString().padStart(2, '0');
        const day = date.getDate().toString().padStart(2, '0');
        return `${year}-${month}-${day}`;
    };

    // Перевірка чи дата активна відповідно до стану чекбоксів
    const isDateActive = (date) => {
        if (watchSat && date.getDay() === 6) return false;
        if (watchSun && date.getDay() === 0) return false;
        return true;
    };

    // Initialize calendar view based on selected dates or tomorrow
    const getInitialCalendarDate = () => {
        if (selectedDates && selectedDates.length > 0) {
            // Use the first selected date to determine which month to show
            return new Date(selectedDates[0]);
        }
        // Fallback to tomorrow if no dates are selected
        const tomorrow = new Date();
        tomorrow.setDate(tomorrow.getDate() + 1);
        return tomorrow;
    };

    const [value, setValueState] = useState(getInitialCalendarDate);

    // Update calendar view when selectedDates changes
    useEffect(() => {
        if (selectedDates && selectedDates.length > 0) {
            const firstSelectedDate = new Date(selectedDates[0]);
            setValueState(firstSelectedDate);
        }
    }, [selectedDates]);

    // Обробка кліку по даті: додаємо або видаляємо з вибраних
    const handleDateClick = (date) => {
        const dateString = formatDate(date);
        if (!isDateActive(date)) return;

        const updatedDates = selectedDates.includes(dateString)
            ? selectedDates.filter(d => d !== dateString)
            : [...selectedDates, dateString];

        setSelectedDates(updatedDates);
        setDays(updatedDates.length);
        setLastSelectedDate(date);
        dispatch(ordersActions.changeSelectedDatesArray(updatedDates));
        setValueState(date);
    };

    // Додаємо клас для підсвічування вибраних дат
    const tileClassName = ({date, view}) => {
        const dateString = formatDate(date);
        if (view === 'month' && selectedDates.includes(dateString)) {
            return 'selected-date';
        }
        return null;
    };

    // Відключення вибору дат, якщо вони є вихідними і відмічені як заборонені
    const tileDisabled = ({date}) => {
        return !isDateActive(date);
    };

    return (
        <div className={css.wrap}>
            <Calendar
                className={css.reactCalendar}
                value={value}
                onClickDay={handleDateClick}
                tileClassName={tileClassName}
                tileDisabled={tileDisabled}
                selectRange={false}
            />
            <style>
                {`
                    .selected-date {
                        background-color: green !important;
                        color: white !important;
                    }
                `}
            </style>
        </div>
    );
};

export {OrdersCalendarModal};

